import {html} from 'lit-html';
import {ifDefined} from 'lit-html/directives/if-defined';
import {live} from 'lit-html/directives/live';
import {classMap} from 'lit-html/directives/class-map';

import TemplateRegistry from '../template/template-registry';
import {
    valueSync, optionClassMap,
    optionDebounce, optionName, optionAutocomplete
} from '../template/template-util.js';

function countDecimals(num) {
    if (Math.floor(num) === num) return 0;
    const str = num.toString();
    if (str.indexOf('.') !== -1 && str.indexOf('e') === -1) {
        return str.split('.')[1].length;
    }
    return 0;
}

function adjustAsInt(currentValue, step, direction, min, max) {
    const current = parseFloat(currentValue) || 0;
    const stepValue = step || 1;
    const decimals = Math.max(countDecimals(current), countDecimals(stepValue));
    const multiplier = Math.pow(10, decimals);

    // Convert to integers for exact arithmetic
    const currentInt = Math.round(current * multiplier);
    const stepInt = Math.round(stepValue * multiplier);

    // Perform exact integer arithmetic
    const newValueInt = currentInt + (stepInt * direction);

    // Convert back to decimal
    const newValue = newValueInt / multiplier;

    // Apply appropriate constraint based on direction
    return direction > 0
        ? Math.min(newValue, max || Number.MAX_SAFE_INTEGER)
        : Math.max(newValue, min || 0);
}

function incrementValue(currentValue, step, max) {
    return adjustAsInt(currentValue, step, 1, 0, max);
}

function decrementValue(currentValue, step, min) {
    return adjustAsInt(currentValue, step, -1, min, Number.MAX_SAFE_INTEGER);
}

// NEW: step="any" to allow decimals - we could make this configurable in the future but then need to handle validation for validity.stepMismatch
TemplateRegistry.templates['number'] = (option, config, onChange)  => {
    // NEW: steps button support (based on quantity discount input)
    if(option.params.numberSteps) {
        return html`
            <div class="cl-po--quantity-wrap cl-po--number-steps">
                <span class="cl-po--quantity-btn" @click=${(e) => {option.value = decrementValue(option.value, option.params.numberStep || 1, option.params.min || 0); onChange(option);}}>-</span>
                <input type="number" class="cl-po--input cl-po--quantity ${classMap(optionClassMap(option))}" id="${option.id}" name="${optionName(option)}" .value=${live(option.value)} @input=${optionDebounce(option, (e) => valueSync(e, option, onChange))}
                       ?required=${option.required} step="any" min=${ifDefined(option.params.min)} max=${ifDefined(option.params.max)} placeholder=${ifDefined(option.params.placeholder)} autocomplete="${optionAutocomplete(option)}" form=${ifDefined(config.productFormLink)}>
                <span class="cl-po--quantity-btn" @click=${(e) => {option.value = incrementValue(option.value, option.params.numberStep || 1, option.params.max || Number.MAX_SAFE_INTEGER); onChange(option);}}>+</span>
            </div>
        `;
    } else {
        return html`
            <input type="number" class="cl-po--input ${classMap(optionClassMap(option))}" id="${option.id}" name="${optionName(option)}" .value=${live(option.value)} @input=${optionDebounce(option, (e) => valueSync(e, option, onChange))}
                   ?required=${option.required} step="any" min=${ifDefined(option.params.min)} max=${ifDefined(option.params.max)} placeholder=${ifDefined(option.params.placeholder)} autocomplete="${optionAutocomplete(option)}" form=${ifDefined(config.productFormLink)}>
        `;
    }
}